"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**************************************** PROJECT MODULES *****************************************/
var kotlin_map_factory_1 = require("../../util/kotlin-map-factory");
// Note: PHUConfigInstance import required for export typings to work
var javelin_exports_1 = require("../../javelin-exports");
// Local phuConfigData (phu config) JSON file
// const phuConfigData: PHUConfigData[] = require('../sources/phu-configs.json');
/******************************************** LOGGING *********************************************/
var util_1 = require("util");
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('phu-configs.ts', shared_1.Styles.bracelet, util_1.inspect);
/******************************************** HELPERS *********************************************/
/**
 * PHUConfig factory
 * Build PHUConfig objects from data in phu-configs.json
 */
var buildPhuConfig = function (phuConfigJson) {
    return new javelin_exports_1.PHUConfig(phuConfigJson.phuId, kotlin_map_factory_1.dirtyKotlinMap(phuConfigJson.phuNames), phuConfigJson.isEnabled, phuConfigJson.color, phuConfigJson.colorDark, phuConfigJson.iconUrl, kotlin_map_factory_1.dirtyKotlinMap(phuConfigJson.consentTexts), kotlin_map_factory_1.dirtyKotlinMap(phuConfigJson.consentTextsRich), phuConfigJson.maxAge, kotlin_map_factory_1.dirtyKotlinMap(phuConfigJson.headerUrls), kotlin_map_factory_1.dirtyKotlinMap(phuConfigJson.modalHeaderUrls), kotlin_map_factory_1.dirtyKotlinMap(phuConfigJson.webModalHeaderUrls), phuConfigJson.cityIds);
};
/****************************************** DATA EXPORT *******************************************/
/**
 * Build array of PHUConfig objects from given [phuConfigData] array
 * Data should be loaded from remote URL
 */
exports.phuConfigs = function (phuConfigData) {
    var hydratedPHUConfigs = phuConfigData.map(buildPhuConfig);
    log.verbose("hydratedPHUConfigs:", util_1.inspect(hydratedPHUConfigs, false, 10, true));
    return hydratedPHUConfigs;
};
//# sourceMappingURL=phu-configs.js.map